import { Route, Routes } from "react-router-dom";
import Error404Page from "./pages/Error404Page/Error404Page";
import VCNOnboardingPage from "./pages/VCNOnboardingPage/VCNOnboardingPage";

const OnboardingRoutes = () => {
  return (
    <div className="onboarding-page">
      <Routes>
        <Route path="/vcn" element={<VCNOnboardingPage />} />
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </div>
  );
};

export default OnboardingRoutes;
